export default __webpack_public_path__ + "static/media/TP_sprite_card.bfeaeeab.png";